import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { customersAPI } from "components/Apis/customers";

export const fetchCustomerMargins = createAsyncThunk(
    'customers/fetchCustomerMargins',
    async (
        {
            startDate,
            endDate,
            page = 1,
            pageSize = 10,
            ordering = 'revenue',
            searchTerm = ''
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await customersAPI.getCustomerMargins(startDate, endDate, page, pageSize, ordering, searchTerm);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

export const fetchAllCompaniesMarginsPerDate = createAsyncThunk(
    'customers/fetchMarginsPerDate',
    async (
        {
            startDate,
            endDate,
            searchTerm = '',
            ordering = 'revenue',
            granularity = 'day',
        },
        { rejectWithValue }
    ) => {
        try {
            const response = await customersAPI.getAllCompaniesMarginsPerDate(startDate, endDate, searchTerm, ordering, granularity);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
)

const customerSlice = createSlice({
    name: 'customers',
    initialState: {
        customerMargins: { loading : false, error: null, data: null },
        allCompaniesMarginsPerDate: { loading : false, error: null, data: null },
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCustomerMargins.pending, (state) => {
                state.customerMargins.loading = true;
                state.customerMargins.error = null;
            })
            .addCase(fetchCustomerMargins.fulfilled, (state, action) => {
                state.customerMargins.loading = false;
                state.customerMargins.data = action.payload;
            })
            .addCase(fetchCustomerMargins.rejected, (state, action) => {
                state.customerMargins.loading = false;
                state.customerMargins.error = action.payload;
            });
        builder
            .addCase(fetchAllCompaniesMarginsPerDate.pending, (state) => {
                state.allCompaniesMarginsPerDate.loading = true;
                state.allCompaniesMarginsPerDate.error = null;
            })
            .addCase(fetchAllCompaniesMarginsPerDate.fulfilled, (state, action) => {
                state.allCompaniesMarginsPerDate.loading = false;
                state.allCompaniesMarginsPerDate.data = action.payload;
            })
            .addCase(fetchAllCompaniesMarginsPerDate.rejected, (state, action) => {
                state.allCompaniesMarginsPerDate.loading = false;
                state.allCompaniesMarginsPerDate.error = action.payload;
            });
    },
});

export default customerSlice.reducer;
